export const setEnvironmentSpecificStyles = function (settings) {
  const vuetify = useNuxtApp().$vuetify;
  if (vuetify && settings.styleV2) {
    const parsedSettings = settings.styleV2;
    const html = document.getElementsByTagName('html')[0];
    Object.keys(vuetify.theme.themes._value.light.colors || {}).forEach((key) => {
      const newColor = colorKeyMap.hasOwnProperty(key) ? parsedSettings[colorKeyMap[key]] : parsedSettings[key];
      if (newColor) {
        vuetify.theme.themes._value.light.colors[key] = newColor;
        window.vuetifyOptions.theme.themes.light.colors[key] = newColor;
        html.style.setProperty(`--v-theme-${key}`, newColor);
        html.style.setProperty(`--${key}`, newColor);
      }
    });
  }
};

// Temporary for now, we can change it later to align with new names.
const colorKeyMap = {
  'on-primary': 'primaryText',
  'primary-hover': 'primaryHover',
  'on-surface': 'text',
  'on-background': 'text',
  'primary-border': 'border',
  'nav-drawer-icon': 'drawerIcon',
  'disabled-bg': 'disabled',
  'disabled-text': 'disabledText',
  'tab-color': 'tabBorder',
  'error-hover': 'errorHover',
  'app-header': 'appHeader'
};
